import React from "react";
import { Select, ConfigProvider } from "antd";

import { Colors } from "../../config";

import { FaChevronDown } from "react-icons/fa";

import "./styles.css";

const handleFilter = (input, option) => {
  if (!option || !option.label) return false;
  return option.label.toString().toLowerCase().startsWith(input.toLowerCase());
};

const SelectDropdownTags = ({
  showSearch = true,
  placeholder = "Select",
  loading = false,
  items = [],
  disabled = false,
  ...props
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            controlOutline: "none",
            colorPrimaryTextActive: Colors.main,
            colorPrimaryHover: Colors.main,
            colorPrimaryActive: Colors.main,
            colorPrimaryBorder: Colors.main,
            optionSelectedBg: Colors.liteBoxBorder,
            multipleItemBorderColor: Colors.liteBoxBorder,
            multipleItemBg: Colors.liteBoxBg,
            multipleItemHeight: 36,
          },
        },
        token: {
          colorBorder: Colors.main,
          borderRadius: 10,
        },
      }}
    >
      <Select
        showSearch={showSearch}
        placeholder={placeholder}
        loading={loading}
        suffixIcon={<FaChevronDown color={Colors.main} fontSize={"1.125em"} />}
        className={`default-select-dropdown ${
          disabled
            ? "default-select-dropdown-multiple-disabled"
            : "default-select-dropdown-multiple"
        }`}
        mode="tags"
        filterOption={handleFilter}
        disabled={disabled}
        options={items.map((item) => ({
          label: item?.label,
          value: item?.value,
        }))}
        {...props}
      />
    </ConfigProvider>
  );
};

export default SelectDropdownTags;
